import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const ScrollButton = styled.button<{ $isVisible: boolean }>`
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 56px;
  height: 56px;
  background: ${theme.colors.outchou_blue};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transform: ${props => props.$isVisible ? 'translateY(0)' : 'translateY(20px)'};
  z-index: 1000;

  &:hover {
    background: ${theme.colors.outchou_blue_hover || '#2c5aa0'};
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    right: 16px;
    bottom: 16px;
    width: 48px;
    height: 48px;
  }

  @media (max-width: 480px) {
    right: 12px;
    bottom: 12px;
    width: 44px;
    height: 44px;
  }
`;

const ArrowIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 12px solid white;
  margin-bottom: 2px;

  @media (max-width: 768px) {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid white;
  }

  @media (max-width: 480px) {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid white;
  }
`;

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true); // Toujours visible pour test

  // Fonction pour scroller vers le haut
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Détecter si l'utilisateur a scrollé
  useEffect(() => {
    const toggleVisibility = () => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      console.log('Scroll position:', scrollY); // Debug
      
      if (scrollY > 100) { // Réduit le seuil pour test
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Vérifier immédiatement
    toggleVisibility();
    
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <ScrollButton $isVisible={isVisible} onClick={scrollToTop} aria-label="Retour en haut de page">
      <ArrowIcon />
    </ScrollButton>
  );
};

export default ScrollToTopButton;
